import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { makeStyles } from '@material-ui/core';

const styles = makeStyles(theme => ({
	icon: {
		fontSize: "1.15rem"
	}
}));

function SourceIcon(props) {
	let	classes = styles(),
		{icon, type, color} = props;

	return (
		<FontAwesomeIcon
			color={color}
			className={`${classes.icon}`}
			title={`${icon || "source"} icon`}
			icon={[type ? type : "fab", icon]} />
	);
}

SourceIcon.defaultProps ={
	color: "#9f9f9f"
};

SourceIcon.propTypes = {
	icon: PropTypes.string,
	type: PropTypes.string,
	color: PropTypes.string
};

export default SourceIcon;